// ts-gql-integrity:f60a954e8253d7906a13ea85a73f6d16
/*
ts-gql-meta-begin
{
  "hash": "3fb9c83853a581ae95d434dacf2f36fc"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type UseGetUserPermissionsQueryQueryVariables = SchemaTypes.Exact<{
  bookId: SchemaTypes.Scalars['ID'];
}>;


type UseGetUserPermissionsQueryQuery = { readonly __typename: 'Query', readonly authenticatedUser: { readonly __typename: 'User', readonly id: string, readonly allPermissions: ReadonlyArray<string> | null } | null };



export type type = TypedDocumentNode<{
  type: "query";
  result: UseGetUserPermissionsQueryQuery;
  variables: UseGetUserPermissionsQueryQueryVariables;
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    UseGetUserPermissionsQuery: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"UseGetUserPermissionsQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"bookId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"ID\"}}},\"directives\":[]}],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"authenticatedUser\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allPermissions\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"bookId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"bookId\"}}}],\"directives\":[]}]}}]}}]}")
